"use client";

import { getQualityColor } from "./utils";
import { CHOGHADIYA_MEANINGS, CHOGHADIYA_RESULT_COPY, type ChoghadiyaLanguage } from "./copy";

export function ChoghadiyaLegend({ language = "en" }: { language?: ChoghadiyaLanguage }) {
  const copy = CHOGHADIYA_RESULT_COPY[language];
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-center gap-3 text-caption font-medium">
        {(["best", "good", "neutral", "bad"] as const)
          .map((quality, i) => ({ label: copy.legend[i], quality }))
          .map(({ label, quality }) => {
            const colors = getQualityColor(quality);
            return (
              <span key={quality} className="flex items-center gap-1.5">
                <span
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: colors.text }}
                />
                <span className="text-text-secondary">{label}</span>
              </span>
            );
          })}
      </div>

      <div className="overflow-x-auto rounded-lg border border-border-subtle bg-surface-raised p-3">
        <table className="w-full text-left text-body-small">
          <thead>
            <tr className="border-b border-border-subtle text-caption uppercase text-text-secondary">
              <th className="py-2 px-2">{copy.legendColumns[0]}</th>
              <th className="py-2 px-2">{copy.legendColumns[1]}</th>
              <th className="py-2 px-2">{copy.legendColumns[2]}</th>
            </tr>
          </thead>
          <tbody className="divide-y border-border-subtle">
            {CHOGHADIYA_MEANINGS.map((item) => (
              <tr key={item.name} className="hover:bg-surface-pressed transition">
                <td className="py-2 px-2 font-semibold text-text-primary">{item.name}</td>
                <td className="py-2 px-2">
                  <span className="text-caption font-semibold px-2 py-0.5 rounded-full border border-border-subtle inline-block">
                    {item.meaning[language]}
                  </span>
                </td>
                <td className="py-2 px-2 text-text-secondary">{item.bestFor[language]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
